import React, { useState } from "react";

const BuyerAgreement = ({ isChecked, handleFormValues }) => {
  return (
    <div className="wantad-type-wrap pb-0">
      <div className="row">
        <label className={"check-wrap mb-3"}>
          <input
            type="checkbox"
            name="property_checkbox"
            checked={isChecked}
            onChange={(e) => {
              handleFormValues({ buyersAgreementSigned: e.target.checked });
            }}
          />
          <span>
            <div className="wantad-type-info">
              <h2 className={false ? "pb-0 red-marked-subheading" : " pb-0 wanted-info-list"}>
                Buyer Agreement Form Signed
              </h2>
            </div>
          </span>
        </label>
      </div>
    </div>
  );
};

export default BuyerAgreement;
